/**
 * WithoutNav — layout wrapper for unauthenticated routes.
 *
 * Renders the route `<Outlet>` without the application navbar or title bar.
 * Used for Login, ForgotPassword, VerifyOtp, and ResetPassword.
 */
import { Outlet } from "react-router-dom";

const WithoutNav = () => <Outlet />;

export default WithoutNav;
